export default "__VITE_ASSET__DjucwN3Y__"